import React, { useState, SyntheticEvent, useContext, useEffect } from 'react';

// muiv5
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { Auth } from 'aws-amplify';
import { MenuItem } from '@material-ui/core';
import sortLabelInfo from '../CBER/utils';

// store
import Store from '../../store';
import Actions from '../../store/actions';

// api
import { submitLabelPageCurationDetails, submitLabelProcessedDetails } from '../../api/Cder';

// styles
import styles from './styles/PageNumberEdit.styles';
import TextFieldCard from '../TextFieldCard';

const labelInfo = [
  {
    id: 'indications_and_usage',
    labelName: 'Indications And Usage'
  },
  {
    id: 'dosage_and_administration',
    labelName: 'Dosage And Administration'
  },
  {
    id: 'contraindications',
    labelName: 'Contraindications'
  },
  {
    id: 'warnings',
    labelName: 'Warnings'
  },
  {
    id: 'precautions',
    labelName: 'Precautions'
  },
  {
    id: 'adverse_reactions',
    labelName: 'Adverse Reactions'
  },
  {
    id: 'drug_abuse_and_dependence',
    labelName: 'Drug Abuse And Dependence'
  },
  {
    id: 'overdosage',
    labelName: 'Overdosage'
  },
  {
    id: 'description',
    labelName: 'Description'
  },
  {
    id: 'clinical_pharmacology',
    labelName: 'Clinical Pharmacology'
  },
  {
    id: 'clinical_studies',
    labelName: 'Clinical Studies'
  },
  {
    id: 'how_supplied',
    labelName: 'How Supplied'
  }
];
const NonPLRPage = ({
  format,
  docsId,
  closeEdit,
  labelCachedData,
  processedFormat,
  handleNext
}: any) => {
  type LabelData = {
    dosage_and_administration: number;
    contraindications: number;
    warnings: number;
    precautions: number;
    adverse_reactions: number;
    drug_abuse_and_dependence: number;
    overdosage: number;
    description: number;
    clinical_pharmacology: number;
    clinical_studies: number;
    how_supplied: number;
    indications_and_usage: number;
    qc_status: string;
    disabled_sections: Array<any>;
    [key: string]: number | string | Array<any>;
  };
  const { dispatch } = useContext<any>(Store);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [labelData, setLabelData] = useState<LabelData>({
    dosage_and_administration: 0,
    contraindications: 0,
    warnings: 0,
    precautions: 0,
    adverse_reactions: 0,
    drug_abuse_and_dependence: 0,
    overdosage: 0,
    description: 0,
    clinical_pharmacology: 0,
    clinical_studies: 0,
    how_supplied: 0,
    indications_and_usage: 0,
    qc_status: 'qced',
    disabled_sections: []
  });
  useEffect(() => {
    setLabelData({
      description: labelCachedData.description ?? 0,
      clinical_pharmacology: labelCachedData.clinical_pharmacology ?? 0,
      indications_and_usage: labelCachedData.indications_and_usage ?? 0,
      contraindications: labelCachedData.contraindications ?? 0,
      warnings: labelCachedData.warnings ?? 0,
      precautions: labelCachedData.precautions ?? 0,
      adverse_reactions: labelCachedData.adverse_reactions ?? 0,
      drug_abuse_and_dependence: labelCachedData.drug_abuse_and_dependence ?? 0,
      overdosage: labelCachedData.overdosage ?? 0,
      dosage_and_administration: labelCachedData.dosage_and_administration ?? 0,
      how_supplied: labelCachedData.how_supplied ?? 0,
      clinical_studies: labelCachedData.clinical_studies ?? 0,
      qc_status: labelCachedData.qc_status?.toLowerCase() || 'qced',
      disabled_sections: labelCachedData.disabled_sections ?? []
    });
  }, []);
  const handleSubmit = async (event: SyntheticEvent<HTMLFormElement>, isNextSubmit = false) => {
    try {
      event.preventDefault();
      const user = await Auth.currentUserInfo();
      const payload = {
        description: labelData.description ?? 0,
        clinical_pharmacology: labelData.clinical_pharmacology ?? 0,
        indications_and_usage: labelData.indications_and_usage ?? 0,
        contraindications: labelData.contraindications ?? 0,
        warnings: labelData.warnings ?? 0,
        precautions: labelData.precautions ?? 0,
        adverse_reactions: labelData.adverse_reactions ?? 0,
        drug_abuse_and_dependence: labelData.drug_abuse_and_dependence ?? 0,
        overdosage: labelData.overdosage ?? 0,
        dosage_and_administration: labelData.dosage_and_administration ?? 0,
        clinical_studies: labelData.clinical_studies ?? 0,
        how_supplied: labelData.how_supplied ?? 0,
        qc_status: labelData.qc_status.toLowerCase(),
        curator_email: user.attributes.email,
        curator_name: user.attributes['custom:user']
      };
      let res;
      if (processedFormat) {
        res = await submitLabelProcessedDetails(format.toLowerCase(), docsId, payload);
      } else {
        res = await submitLabelPageCurationDetails(format.toLowerCase(), docsId, payload);
      }
      if (!res?.data || res.status !== 200) {
        await dispatch({
          type: Actions.SET_ALERT,
          value: { status: true, message: `Error while Submitting ${docsId}` }
        });
      } else if (res.data.body) {
        if (isNextSubmit) {
          handleNext();
        } else {
          closeEdit();
        }
        await dispatch({
          type: Actions.SET_ALERT,
          value: { status: true, message: res.data.body, color: 'success' }
        });
      }
    } catch (e: any) {
      await dispatch({
        type: Actions.SET_ALERT,
        value: { status: true, message: e.message }
      });
    }
  };

  const handleNextSubmit = (event: any) => {
    event.preventDefault();
    handleSubmit(event, true);
  };

  return (
    <form
      onSubmit={(event: any) => {
        handleSubmit(event);
      }}
      style={styles.form}>
      <Grid container maxHeight='90vh'>
        <Grid item xs={12} display='flex' direction='column'>
          {sortLabelInfo(labelInfo, labelData).map(arg => {
            return (
              <TextFieldCard
                key={arg.id}
                id={arg.id}
                labelName={arg.labelName}
                data={labelData}
                setData={setLabelData}
                setDisableSubmit={setDisableSubmit}
              />
            );
          })}
          <TextField
            variant='outlined'
            id='status'
            label='QC Status'
            select
            fullWidth
            required
            value={labelData.qc_status}
            onChange={e => setLabelData(prevData => ({ ...prevData, qc_status: e.target.value }))}
            InputProps={{
              style: { fontSize: '1.5vh', minWidth: '250px' }
            }}
            InputLabelProps={{
              style: { fontSize: '1.5vh' }
            }}>
            <MenuItem value='qced'>Qced</MenuItem>
            <MenuItem value='to_qc'>To QC</MenuItem>
            <MenuItem value='escalate'>Escalate</MenuItem>
            <MenuItem value='missing details'>Missing Details</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} display='flex' direction='row' justifyContent='space-around'>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            disabled={disableSubmit}
            sx={styles.submit}
            style={{ color: 'white', width: '45%' }}>
            SUBMIT
          </Button>
          <Button
            type='button'
            variant='contained'
            color='primary'
            sx={styles.submit}
            onClick={e => handleNextSubmit(e)}
            style={{ color: 'white', width: '45%' }}>
            NEXT
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default NonPLRPage;
